/* THIS FILE WAS AUTO-GENERATED. DO NOT MODIFY */
/* eslint-disable */
import * as SchemaTypes from '../../../types/graph';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateWaitingPeriodMutationVariables = SchemaTypes.Exact<{
  input: SchemaTypes.UpdateWaitingPeriodInput;
}>;


export type UpdateWaitingPeriodMutation = { __typename?: 'Mutation', updateWaitingPeriod: { __typename?: 'WaitingPeriod', id: string, waitingPeriod: number } | null };


export const UpdateWaitingPeriodDocument = gql`
    mutation UpdateWaitingPeriod($input: UpdateWaitingPeriodInput!) {
  updateWaitingPeriod(input: $input) {
    id
    waitingPeriod
  }
}
    `;
export type UpdateWaitingPeriodMutationFn = Apollo.MutationFunction<UpdateWaitingPeriodMutation, UpdateWaitingPeriodMutationVariables>;
export function useUpdateWaitingPeriodMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWaitingPeriodMutation, UpdateWaitingPeriodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWaitingPeriodMutation, UpdateWaitingPeriodMutationVariables>(UpdateWaitingPeriodDocument, options);
      }
export type UpdateWaitingPeriodMutationHookResult = ReturnType<typeof useUpdateWaitingPeriodMutation>;
export type UpdateWaitingPeriodMutationResult = Apollo.MutationResult<UpdateWaitingPeriodMutation>;
export type UpdateWaitingPeriodMutationOptions = Apollo.BaseMutationOptions<UpdateWaitingPeriodMutation, UpdateWaitingPeriodMutationVariables>;